import { render, staticRenderFns } from "./CIndex.vue?vue&type=template&id=de318c3c&scoped=true&"
import script from "./CIndex.vue?vue&type=script&lang=js&"
export * from "./CIndex.vue?vue&type=script&lang=js&"
import style0 from "./CIndex.vue?vue&type=style&index=0&id=de318c3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de318c3c",
  null
  
)

export default component.exports